module.exports = __webpack_public_path__ + "img/pin-white.svg";